export default ()=> {
	if (typeof window === 'undefined') {
		return false;
	}
	let html = document.querySelector('html');
	let ua = window.navigator.userAgent;
	let msie = ua.indexOf('MSIE ');

	if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		html?.classList.add('is-ie');
		return true;
	}
	return false;
}
